module.exports = __webpack_public_path__ + "static/lottery-m-43c9a6ee54af115e30be83376cae37fa.svg";